export enum QuestionType {
    None = 0,
    RadioButton = 1,
    DropDownList = 2,
    CheckBox = 3,
    Slider = 4,
    ImageSelector = 5,
    TextAnswer = 6,
    NumericAnswer = 7,
    EmailAddressAnswer = 8,
    DateTimeAnswer = 9,
    OpenEndAnswer = 10,
    CardSort = 11,
    DragDropRanking = 12,
    CustomQuestion = 13,
    HybridGrid = 14,
    RunningTotal = 15,
    ChoiceGrid = 16,
    ImageChoiceGrid = 17,
    RespondentLanguage = 18,
    RespondentTimeZone = 19,
    RespondentEmail = 20,
    Description = 21,
    ImageAreaEvaluator = 22,
    DrillDown = 23,
    RespondentMetaData = 24,
    ImageAreaSelector = 25,
    StarRatingGrid = 26,
    AutoComplete = 27,
    LookupTable = 28,
    FileUpload = 29,
    NetPromoter = 30,
    RespondentPhone = 31,
    Timer = 32,
    NumericRanking = 33,
    Signature = 34,
    TextHighlighter = 35,
    SecuredTemporaryVariable = 36,
    HeatMap = 37,
    Carrousel = 38,
}

export function isGrid(type: QuestionType) {
    switch (type) {
        case QuestionType.HybridGrid:
        case QuestionType.RunningTotal:
        case QuestionType.ChoiceGrid:
        case QuestionType.ImageChoiceGrid:
        case QuestionType.StarRatingGrid:
            return true;
        default:
            return false;
    }
}

export function isChoiceList(type: QuestionType) {
    switch (type) {
        case QuestionType.RadioButton:
        case QuestionType.CheckBox:
        case QuestionType.ImageSelector:
            return true;
        default:
            return false;
    }
}

export function isImage(type: QuestionType) {
    switch (type) {
        case QuestionType.ImageAreaEvaluator:
        case QuestionType.ImageAreaSelector:
        case QuestionType.ImageChoiceGrid:
        case QuestionType.ImageSelector:
            return true;
        default:
            return false;
    }
}
